"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _utils = require("../../../services/ui/utils");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
class SpatialFilterPanel extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterSelected: _OctaviParameters.default.get('filterSelected', "FilterOne"),
      filters: _OctaviParameters.default.filters,
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.onButtonSelectClick = this.onButtonSelectClick.bind(this);
    this.updateFilterSelection = this.updateFilterSelection.bind(this);
    this.updateDataSourceIds = this.updateDataSourceIds.bind(this);
    this.updateFilter = this.updateFilter.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.on('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.on('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.on('taxi.filter.data.update', this.updateFilter);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.off('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.off('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.off('taxi.filter.data.update', this.updateFilter);
  }
  updateDataSourceIds() {
    this.setState({
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    });
  }
  updateFilterSelection() {
    this.setState({
      filterSelected: _OctaviParameters.default.filterSelected
    });
  }
  updateFilter() {
    this.setState({
      filters: _OctaviParameters.default.filters
    });
  }
  onButtonClick(name) {
    // name is name of the clicked button must be "origin" or "destination"
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const generalSwitchState = this.state.filters[filterIdx].spatialFilterIsSelected;

    // if switch is set to off when clicking we set switch to on and only set clicked button to on
    if (!generalSwitchState) {
      newFilters[filterIdx]['originIsSelected'] = name == "origin" ? true : false;
      newFilters[filterIdx]['destinationIsSelected'] = name == "destination" ? true : false;
      newFilters[filterIdx]['spatialFilterIsSelected'] = true;

      //else we switch correspondinf filter
    } else {
      if (name === 'origin') {
        newFilters[filterIdx]['originIsSelected'] = !newFilters[filterIdx]['originIsSelected'];
      } else if (name === 'destination') {
        newFilters[filterIdx]['destinationIsSelected'] = !newFilters[filterIdx]['destinationIsSelected'];
      }

      // if all filters are on off we also set switch to off
      if (!newFilters[filterIdx]['originIsSelected'] && !newFilters[filterIdx]['destinationIsSelected']) {
        newFilters[filterIdx]['spatialFilterIsSelected'] = false;
      }
    }

    //update filter values
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onSwitchChange() {
    const newFilters = (0, _lodash.cloneDeep)(this.state.filters);
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    const previousGeneralSwitchState = this.state.filters[filterIdx].spatialFilterIsSelected;
    newFilters[filterIdx]['spatialFilterIsSelected'] = !previousGeneralSwitchState;

    // if we select filter, we make sure to have at list origine or destination sleected
    if (newFilters[filterIdx]['spatialFilterIsSelected']) {
      // if no filter
      if (!newFilters[filterIdx]['originIsSelected'] && !newFilters[filterIdx]['destinationIsSelected']) {
        newFilters[filterIdx]['originIsSelected'] = true;
        newFilters[filterIdx]['destinationIsSelected'] = false;
      }
    }
    //update filter values
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  onButtonSelectClick(name) {
    if (name == "origin") {
      _ServiceLocator.default.eventManager.emit('taxi.filter.selectOrigin.request');
    } else if (name == "destination") {
      _ServiceLocator.default.eventManager.emit('taxi.filter.selectDestination.request');
    }
  }
  render() {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    if (this.state.dataSourceIds.length === 0 || this.state.filters.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    const originDistricts = this.state.filters[filterIdx]['selectedOriginDistricts'] || [];
    const destinationDistricts = this.state.filters[filterIdx]['selectedDestinationDistricts'] || [];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__form-input-container _margin_bottom_small"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_margin_bottom_small _bottom_border"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_filter_section _space-between-columns _margin_bottom_small"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "_left"
    }, this.props.t('octavi:filters:spatial:sectionName')), /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
      id: `formFieldTaxiActivitiesSelectSpatialFilter`,
      onChange: this.onSwitchChange,
      checked: this.state.filters[filterIdx][`spatialFilterIsSelected`],
      onColor: "#609112",
      height: 25
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_filter_section _space-between-columns"
    }, /*#__PURE__*/_react.default.createElement("button", {
      id: `formFieldTaxiActivitiesSelectSpatialFilterOrigin`,
      className: this.state.filters[filterIdx][`originIsSelected`] && this.state.filters[filterIdx][`spatialFilterIsSelected`] ? "button green _three_columns" : "button grey _three_columns",
      type: "button",
      onClick: x => this.onButtonClick("origin")
    }, this.props.t('octavi:filters:spatial:origin')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_right"
    }, `${originDistricts.length} ${this.props.t("octavi:filters:spatial:zoneCount")}`))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_filter_section _space-between-columns"
    }, /*#__PURE__*/_react.default.createElement("button", {
      id: `formFieldTaxiActivitiesSelectSpatialFilterDestination`,
      className: this.state.filters[filterIdx][`destinationIsSelected`] && this.state.filters[filterIdx][`spatialFilterIsSelected`] ? "button green _three_columns" : "button grey _three_columns",
      type: "button",
      onClick: x => this.onButtonClick("destination")
    }, this.props.t('octavi:filters:spatial:destination')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_right"
    }, `${destinationDistricts.length} ${this.props.t("octavi:filters:spatial:zoneCount")}`))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "2em"
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "_input _input-select-button",
      style: {
        display: "inline-block"
      },
      type: "button",
      onClick: x => this.onButtonSelectClick("origin")
    }, this.props.t('octavi:filters:spatial:select'))));
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(SpatialFilterPanel);